import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="leanpub" {...props} />;
}

export const meta = {
  id: 'CMS',
  title: 'CMS',
  category: 'CMS',
  exposes: [
    // {
    //   title: 'Pages',
    //   action: { module: 'CMS', props: { /* */ } },
    //   desription: 'general-desc',
    // },
    // {
    //   title: 'New page',
    //   action: { module: 'CMS', props: { context: 'addPage' } },
    //   desription: 'general-desc',
    // },
    // {
    //   title: 'Categories',
    //   action: { module: 'CMS', props: { /* */ } },
    //   desription: 'general-desc',
    // },
    // {
    //   title: 'Tags',
    //   action: { module: 'CMS', props: { /* */ } },
    //   desription: 'general-desc',
    // },
    // {
    //   title: 'Menus',
    //   action: { module: 'CMS', props: { /* */ } },
    //   desription: 'general-desc',
    // },
    // // {
    // //   title: 'Settings',
    // //   action: { module: 'CMS', props: { /* */ } },
    // //   desription: 'general-desc',
    // // },
    // // {
    // //   title: 'Analytics',
    // //   action: { module: 'CMS', props: { /* */ } },
    // //   desription: 'general-desc',
    // // },
  ],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `The main CMS module with a longer description about the CMS tooling`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
